import axios from 'axios'

const LocationService = {
  async get (params = {}) {
    return axios.get('admin/locations', { params })
  },

  async post (params = {}) {
    return axios.post('admin/locations', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`admin/locations/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`admin/locations/${data.id}`, { data })
  }
}

export default LocationService
